/** Gateway paths scoped to the current marketplace publisher/payee. */
export const marketplacePublisherPaths = {
  earnings: () => '/publishers/me/earnings',
  accessRequests: () => '/publishers/me/access-requests',
  providerBindings: () => '/publishers/me/provider-bindings',
  offers: () => '/publishers/me/offers',
  offer: (slug) => `/publishers/me/offers/${encodeURIComponent(slug)}`,
  submitOffer: (slug) => `/publishers/me/offers/${encodeURIComponent(slug)}/submit`,
};

export default marketplacePublisherPaths;
